/**
 * Temporary feature gates.
 *
 * Everything here is meant to be DELETED, not maintained. Each flag carries
 * why it exists and what has to be true before it goes.
 */

/**
 * TEMPORARY — hide the Brand Tracker from Japanese-language users.
 *
 * The tracker's Japanese strings (95 UI keys, the wave readout, and the 19
 * survey questions) are AI-translated and have not had a native review. The
 * survey questions matter most: respondents read those directly and awkward
 * phrasing depresses response quality, which would show up as bad data rather
 * than as an obvious bug.
 *
 * Safe to hide as of 2026-08-14: there are zero Japanese-language BRAND001
 * trackers in production or dev, so nothing existing is stranded. 111
 * production users have a Japanese UI, which is why this is worth gating
 * rather than shipping and hoping.
 *
 * TO REMOVE once the Japanese wording has been reviewed: delete this function
 * and its three call sites (MySideNav, StartPoint, and the /brand-tracker*
 * routes in Main.js). Nothing else depends on it.
 */
export const isBrandTrackerHidden = (language) =>
  String(language || '').toLowerCase().startsWith('ja');

export default { isBrandTrackerHidden };
